module.exports = __webpack_public_path__ + "media/images/venipak-80abb992.svg";